import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'
import LoginView from '../views/Loginview.vue'
import AdminView from '../views/Admin/Adminview.vue'
import FixerDashboard from '../views/Fixer/FixerDashboard.vue'
import HomeView from '../views/Home/Homeview.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminView,
    meta: { requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_AFTER_SALES'] }
  },
  {
    path: '/fixer',
    name: 'FixerDashboard',
    component: FixerDashboard,
    meta: { 
      requiresAuth: true,
      roles: ['ROLE_TECHNICIAN']
    }
  }
  // 重定向规则（移除 /admin -> /home 的旧重定向）
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  
  // 检查是否需要认证
  if (to.meta.requiresAuth) {
    if (!userStore.isLoggedIn) {
      // 未登录，重定向到登录页
      next('/')
      return
    }
    
    // 检查角色权限
    if (to.meta.roles && to.meta.roles.length > 0) {
      const userRole = userStore.userInfo.role
      if (!to.meta.roles.includes(userRole)) {
        // 没有权限，重定向到对应的默认页面（保留 TECHNICIAN 与 ADMIN）
        if (userRole === 'ROLE_TECHNICIAN') {
          next('/fixer')
        } else {
          next('/admin')
        }
        return
      }
    }
  }
  
  if (to.path === '/login' && userStore.isLoggedIn) {
    const userRole = userStore.userInfo.role
    if (userRole === 'ROLE_TECHNICIAN') {
      next('/fixer')
    } else {
      next('/admin')
    }
    return
  }
  
  next()
})

export default router
